<template>
  <div>
    <b-card>
      <page-title v-if="titleStatus" :title="$t('systemSettings.items')" />

      <main-table
        :fields="fields"
        :list_url="'admin/system-settings'"
        :reloadData="reloadData"
        :params="filter"
        :createBtnLabel="$t('systemSettings.create')"
        createRouteName="administration.systemSettingCreate"
        :excelFields="excelFields"
        excelName="systemSettings"
        :downloadSampleStatus="true"
        downloadSampleUrl="system-settings/excel-sample"
        :uploadFileStatus="true"
        uploadFileUrl="system-settings/excel"
      />
    </b-card>
  </div>
</template>
<script>
import { core } from "../../../../config/pluginInit";
import SystemSettingFilter from "../models/SystemSettingFilter";
import searchMixin from "../../../../Mixins/searchMixin";

export default {
  mixins: [searchMixin],
  data() {
    return {
      filter: new SystemSettingFilter(),
      fields: [
        this.$t("global.selected"),
        { key: "id", label: this.$t("table.id"), sortable: true },
        { key: "key", label: this.$t("systemSettings.key"), sortable: true },
        {
          key: "value",
          label: this.$t("systemSettings.value"),
          sortable: true,
        },
        {
          key: "created_at",
          label: this.$t("table.createdAt"),
          type: "dateTime",
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("table.actions"),
          type: "actions",
          actions: [
            {
              text: this.$t("global.view"),
              icon: "fas fa-eye",
              color: "info",
              ifNavigate: true,
              routeName: "administration.systemSettingView",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.update"),
              icon: "fas fa-pen",
              color: "primary",
              ifNavigate: true,
              routeName: "administration.systemSettingUpdate",
              routeParams: ["id"],
            },
          ],
        },
      ],
      excelFields: {
        [this.$t("table.id")]: "id",
        [this.$t("systemSettings.key")]: "key",
        [this.$t("systemSettings.value")]: "value",
        [this.$t("table.createdAt")]: "created_at",
      },
    };
  },
  mounted() {
    core.index();
  },
};
</script>
